export { default as ENTRY } from './entry';
export const PATH = '/videovisit';
export const pageName = 'Telehealth';

export const TELEHEALTH_PROFILE_GA_CATEGORY = 'Telehealth';
export const analytics = {
    pageCategory: () => 'Telehealth',
    rollUpBucket: () => 'Telehealth',
    pageType: () => 'Telehealth',
};
